import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BACKEND_URL } from '../../config';

const API = `${BACKEND_URL}/api`;
const ACHIEVEMENT_ID = 'classified-folder';

const ClassifiedFolder = () => {
  const navigate = useNavigate();
  const [showOffer, setShowOffer] = useState(false);
  const [statusText, setStatusText] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [resolved, setResolved] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const maxAttempts = 2;
  const correctFileId = 'C';

  const files = [
    { id: 'A', label: 'CASE FILE A-1947', desc: 'ROSWELL INCIDENT / UFO ANALYSIS', icon: '🛸' },
    { id: 'B', label: 'CASE FILE B-1963', desc: 'JFK ASSASSINATION / BALLISTICS', icon: '🔫' },
    { id: 'C', label: 'CASE FILE C-2025', desc: 'LOCAL BUSINESS OPERATIONS / TAPPD', icon: '🏢', correct: true },
    { id: 'D', label: 'CASE FILE D-2001', desc: 'AREA 51 / TECH RECOVERY', icon: '📡' }
  ];

  const handleFileClick = async (fileId) => {
    if (resolved) return;
    
    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    setSelectedFile(fileId);

    if (fileId === correctFileId) {
      setResolved(true);
      setStatusText('Correct file selected. TAPPD operations match local business context.');
      
      // Store achievement in sessionStorage
      sessionStorage.setItem('pendingAchievement', ACHIEVEMENT_ID);

      setTimeout(() => {
        setShowOffer(true);
        setTimeout(() => {
          navigate(`/scan?achievement=${ACHIEVEMENT_ID}`);
        }, 1300);
      }, 1100);
    } else {
      if (newAttempts < maxAttempts) {
        setStatusText('Wrong file. Look for the one related to LOCAL BUSINESS OPERATIONS.');
      } else {
        setResolved(true);
        setSelectedFile(correctFileId);
        setStatusText('Too many errors. System auto-selected the TAPPD operations file.');
        
        sessionStorage.setItem('pendingAchievement', ACHIEVEMENT_ID);
        
        setTimeout(() => {
          setShowOffer(true);
          setTimeout(() => {
            navigate(`/scan?achievement=${ACHIEVEMENT_ID}`);
          }, 1300);
        }, 1200);
      }
    }
  };

  return (
    <div style={styles.wrap}>
      {!showOffer ? (
        <div style={styles.terminal}>
          <div style={styles.header}>
            <div style={styles.dots}>
              <span style={styles.dot}></span>
              <span style={styles.dot}></span>
              <span style={styles.dot}></span>
            </div>
            <div style={styles.headerLabel}>CLASSIFIED ARCHIVE SYSTEM</div>
          </div>
          
          <div style={styles.body}>
            <div style={styles.line}>
              <span style={styles.label}>SYSTEM:</span>
              <span style={styles.value}> F.B.I. CLASSIFIED ARCHIVES v3.8</span>
            </div>
            <div style={styles.line}>
              <span style={styles.label}>ACCESS:</span>
              <span style={styles.value}> UNAUTHORIZED / GUEST MODE</span>
            </div>
            <div style={styles.line}>
              <span style={styles.label}>QUERY:</span>
              <span style={styles.value}> LOCAL BUSINESS OPERATIONS</span>
            </div>
            <div style={styles.line}>
              <span style={styles.label}>STATUS:</span>
              <span style={{...styles.value, color: '#ef4444'}}> MULTIPLE MATCHES FOUND</span>
            </div>
            
            <div style={styles.gameTitle}>Select The Correct Case File</div>
            <div style={styles.gameInstruction}>
              Choose the classified folder that matches <strong>LOCAL BUSINESS OPERATIONS</strong>.
            </div>
            
            <div style={styles.filesGrid}>
              {files.map((file) => (
                <div
                  key={file.id}
                  style={{
                    ...styles.file,
                    ...(selectedFile === file.id && resolved ? styles.selected : {}),
                    ...(resolved && file.id !== correctFileId ? styles.disabled : {})
                  }}
                  onClick={() => handleFileClick(file.id)}
                >
                  <div style={styles.fileIcon}>{file.icon}</div>
                  <div style={styles.fileLabel}>{file.label}</div>
                  <div style={styles.fileDesc}>{file.desc}</div>
                </div>
              ))}
            </div>
            
            {statusText && (
              <div style={{
                ...styles.statusText,
                color: resolved ? '#10b981' : '#ef4444'
              }}>
                {statusText}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={styles.offer}>
          <small style={{color: '#10b981', fontWeight: 700}}>FILE ACCESSED</small>
          <div style={styles.offerTitle}>Case file opened.</div>
          <p>You've located the right classified folder. Your <strong>exclusive Tappd offer</strong> is ready.</p>
          <p style={styles.tagline}>Opening file contents…</p>
        </div>
      )}
    </div>
  );
};

const styles = {
  wrap: { minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: '"Courier New", monospace' },
  terminal: { background: '#1e293b', borderRadius: '12px', maxWidth: '600px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.5)', border: '1px solid #334155' },
  header: { background: '#334155', padding: '12px 16px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', display: 'flex', alignItems: 'center', gap: '12px' },
  dots: { display: 'flex', gap: '6px' },
  dot: { width: '12px', height: '12px', borderRadius: '50%', background: '#64748b' },
  headerLabel: { color: '#e2e8f0', fontSize: '14px', fontWeight: 700, letterSpacing: '1px' },
  body: { padding: '24px', color: '#10b981', fontSize: '14px', lineHeight: '1.8' },
  line: { marginBottom: '8px' },
  label: { color: '#fbbf24', fontWeight: 700 },
  value: { color: '#10b981' },
  gameTitle: { color: '#fbbf24', fontSize: '18px', fontWeight: 700, marginTop: '24px', marginBottom: '12px', textTransform: 'uppercase' },
  gameInstruction: { color: '#cbd5e1', fontSize: '14px', marginBottom: '20px' },
  filesGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', marginBottom: '20px' },
  file: { padding: '20px', background: '#0f172a', border: '2px solid #334155', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s', textAlign: 'center' },
  selected: { borderColor: '#10b981', background: 'rgba(16, 185, 129, 0.1)' },
  disabled: { opacity: 0.4, cursor: 'not-allowed' },
  fileIcon: { fontSize: '48px', marginBottom: '12px' },
  fileLabel: { color: '#fbbf24', fontSize: '12px', fontWeight: 700, marginBottom: '8px' },
  fileDesc: { color: '#94a3b8', fontSize: '11px', lineHeight: '1.4' },
  statusText: { fontSize: '14px', fontWeight: 600, textAlign: 'center', marginTop: '16px' },
  offer: { maxWidth: '600px', background: 'white', padding: '40px', borderRadius: '12px', textAlign: 'center', color: '#1e293b' },
  offerTitle: { fontSize: '28px', fontWeight: 700, margin: '16px 0', fontFamily: 'Fraunces, serif' },
  tagline: { color: '#64748b', fontStyle: 'italic', marginTop: '16px' },
};

export default ClassifiedFolder;